/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable @typescript-eslint/no-empty-interface */
/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
/* eslint-disable react/no-unstable-nested-components */
/* eslint-disable no-param-reassign, max-len */
import React, { useMemo, useState } from 'react';
import { createColumnHelper } from '@tanstack/react-table';
import { Paper, Rating, Tooltip } from '@mui/material';
import moment from 'moment';
import CurrentInterviewsFilters from 'src/pages/CurrentInterviews/components/CurrentInterviewsFilters';
import { convertApiDataToTable } from 'src/pages/CompletedInterviews/utils';
import { Table } from 'src/components';
import { confirmWrapper } from 'src/components/Dialog';
import { RowHover } from 'src/components/Table';
import { MdFeedback } from 'react-icons/md';
import { useClients } from 'src/hooks/query/clients';
import { useRoleUser } from 'src/hooks/query/usersByRole';
import { CompletedInterviewsListTable, CompletedInterviewsListValues, CompletedInterviewsViewRendererProps } from '../../types';
import PannaInterviewReportView from '../../components/PannaInterviewReportView';

interface ActionDivProps {
  onFeedback: (data: CompletedInterviewsListValues) => void;
  info: CompletedInterviewsListValues;
}

const ActionDiv = function addAction(actionProps: ActionDivProps) {
  const { onFeedback, info } = actionProps;
  const handleIconClick = (e: React.MouseEvent<HTMLDivElement>) => {
    e.stopPropagation();
    onFeedback(info);
  };
  return (
    <div className="flex flex-row justify-center items-center gap-2">
      <Tooltip title="Feedback">
        <div onClick={handleIconClick}>
          <MdFeedback className="h-5 w-5" />
        </div>
      </Tooltip>
    </div>
  );
};

function Desktop(props: CompletedInterviewsViewRendererProps) {
  const {
    completedInterviewsFetching,
    completedInterviews,
    filters,
    onFeedback,
    onApplyFilter,
    onFiltersReset,
    onChangePagination,
    onUpdateInterviewStatus,
  } = props;

  const { clientOptions } = useClients();

  const payload = { roleNameList: 'ATSInterviewer' };
  const { userByRoleOptions } = useRoleUser(payload);

  const clientIdToNameMap = useMemo(() => {
    const map: Record<string, string> = {};
    clientOptions.forEach((client) => {
      map[client.value] = client.label;
    });
    return map;
  }, [clientOptions]);

  const interviewerIdToNameMap = useMemo(() => {
    const map: Record<string, string> = {};
    userByRoleOptions.forEach((interviewer) => {
      map[interviewer.value] = interviewer.label;
    });
    return map;
  }, [userByRoleOptions]);

  const [rowHover, setRowHover] = useState<RowHover>({});
  const columnHelper = createColumnHelper<CompletedInterviewsListTable>();
  const columns = [columnHelper.accessor('createdDate', {
    header: () => <div className="ml-6">Date</div>,
    cell: (info) => (
      <div className="ml-6">
        <div>
          {moment(info.getValue(), 'ddd MMM DD HH:mm:ss [zzz] YYYY').format('MM/DD/YYYY')}
        </div>
      </div>
    ),
  }), columnHelper.accessor('firstName', {
    header: () => <div className="p-2">Name</div>,
    cell: (info) => (
      <div className="px-2 w-[120px] truncate cursor-pointer" title={`${info.getValue()} ${info.row.original.lastName ? info.row.original.lastName : ''}`}>
        {info.getValue()}
        &nbsp;
        {info.row.original.lastName}
      </div>
    ),
  }), columnHelper.accessor('interviewerId', {
    header: () => <div className="p-2">Interviewer</div>,
    cell: (info) => {
      const interviewerId = info.getValue();
      const interviewerName = interviewerIdToNameMap[interviewerId];
      return (
        <Tooltip title={interviewerName}>
          <div className="px-2 w-[120px] truncate">
            {interviewerName || interviewerId || '-'}
          </div>
        </Tooltip>
      );
    },
  }), columnHelper.accessor('interviewMode', {
    header: () => <div className="p-2">Type</div>,
    cell: (info) => (
      <Tooltip title={info.getValue()}>
        <div className="px-2 w-[100px] truncate">{info.getValue()}</div>
      </Tooltip>
    ),
  }), columnHelper.accessor('interviewPosition', {
    header: () => <div className="p-2">Status</div>,
    cell: (info) => (
      <div className="px-2">
        {info.getValue()}
      </div>
    ),
  }), columnHelper.accessor('interviewId', {
    header: () => <div className="p-2">Interview Date & Time</div>,
    cell: (info) => {
      const displayName = `${info.row.original.interviewDate} ${info.row.original?.timeSlot ? moment(info.row.original?.timeSlot, 'hh:mm A').format('HH:mm:ss') : '00:00:00'}`;
      return (
        <Tooltip title={displayName}>
          <div className="px-2 w-[110px] truncate">
            {info.row.original.interviewDate}
            &nbsp;
            {info.row.original?.timeSlot ? moment(info.row.original?.timeSlot, 'hh:mm A').format('HH:mm:ss') : '00:00:00'}
          </div>
        </Tooltip>
      );
    },
  }), columnHelper.accessor('clientId', {
    header: () => <div className="p-2">Client</div>,
    cell: (info) => {
      const clientName = clientIdToNameMap[info.getValue()];
      return (
        <Tooltip title={clientName}>
          <div className="px-2 max-w-[200px] truncate">
            {clientName}
          </div>
        </Tooltip>
      );
    },
  }), columnHelper.accessor('techSkill', {
    header: () => <div className="p-2">Technical</div>,
    cell: (info) => (
      <span className=" px-2 text-xs col-span-2 text-ellipsis overflow-hidden">
        <Rating size="small" precision={0.5} disabled defaultValue={info.row.original.techSkill || info.row.original.oldTechSkill} />
      </span>
    ),
  }), columnHelper.accessor('communicationSkills', {
    header: () => <div className="p-2">Comm.Skill</div>,
    cell: (info) => (
      <span className="px-2 text-xs col-span-2 text-ellipsis overflow-hidden">
        <Rating size="small" precision={0.5} disabled defaultValue={info.row.original.communicationSkills || info.row.original.oldCommunicationSkills} />
      </span>
    ),
  }), columnHelper.accessor('score', {
    header: () => <div className="p-2">Score</div>,
    cell: (info) => (
      <span className="px-2 text-xs col-span-2 text-ellipsis overflow-hidden">
        <Rating size="small" precision={0.5} disabled defaultValue={info.row.original.score} />
      </span>
    ),
  }), columnHelper.accessor('phoneNumber', {
    header: () => <div className="p-2">Ph.no</div>,
    cell: (info) => (
      <div className="px-2">
        {info.getValue()}
      </div>
    ),
  }), columnHelper.accessor('jobId', {
    header: () => '',
    cell: (info) => (
      <div className="px-2 flex justify-center items-center min-w-[100px] min-h-[40px]">
        {rowHover[info.row.index] && (
          <ActionDiv
            info={info.row.original as CompletedInterviewsListValues}
            onFeedback={onFeedback}
          />
        )}
      </div>
    ),
  })];

  const onRowHover = (data: RowHover) => {
    setRowHover(data);
  };

  const onRowClick = async (e: CompletedInterviewsListValues) => {
    await confirmWrapper('', {
      variant: '',
      hidePrimaryBtn: true,
      hideSecondaryBtn: true,
      maxWidth: 'md',
      fullWidth: true,
      showCloseButton: true,
      disableBackdropClickClose: true,
      disableEscapeKeyDownClose: true,
      dialogContent: (
        <PannaInterviewReportView
          data={e}
          currentInterview={false}
          onSave={onUpdateInterviewStatus}
        />
      ),
    });
  };
  return (
    <div className="py-2">
      <CurrentInterviewsFilters onSubmit={onApplyFilter} onReset={onFiltersReset} currentInterview={false} />
      <Paper className="mb-4 flex items-center justify-center mt-2 default-shadow-table overflow-x-auto">
        <Table
          loading={completedInterviewsFetching}
          data={convertApiDataToTable(completedInterviews)}
          columns={columns}
          title="Completed Interviews"
          pageSize={20}
          onRowClick={onRowClick}
          onRowHover={onRowHover}
          onChangePagination={onChangePagination}
          manualPagination={filters.pagination}
        />
      </Paper>
    </div>
  );
}

export default Desktop;
